module.exports = __webpack_public_path__ + "static/man-with-sea-ie-4f51b424b8244c398db16fea5a2320c2.png";